module.exports = __webpack_public_path__ + "img/lpsl.207d2411.png";